import { iDepoByFromResponse, tDepoMode } from "../interfaces/chrInterfaces";
import { tAvailableFTokens, tAvailableUTokens, tDiscountPercent } from "../interfaces/interfaces";
import { getItemInfoByAddress } from "../utils/Chromia/utils";
import { cBigNumber } from "./BigNumber";

export class cAllInfo {
	freeFt: cBigNumber;
	freeUt: cBigNumber;
	from: {
		buffer: Buffer,
		string: string
	};
	item: {
		buffer: Buffer,
		string: string,
		fToken: tAvailableFTokens,
		uToken: tAvailableUTokens,
		percent: tDiscountPercent
	};
	mode: tDepoMode;
	period: number;
	isPeriodStarted: boolean;
	requestMode: tDepoMode;
	wdRequestdFtPerc: cBigNumber;
	wdRequestdUtPerc: cBigNumber;
	usingFt: cBigNumber;
	usingUt: cBigNumber;

	isActive: boolean;
	/**
	 * Have pending changes.
	 */
	haveChanges: boolean;

	constructor (response: iDepoByFromResponse) {

		const itemId = response.item.toString('hex');

		this.freeFt = new cBigNumber(response.free_ft);
		this.freeUt = new cBigNumber(response.free_ut);
		this.from = {
			buffer: response.from,
			string: response.from.toString('hex')
		};
		this.item = {
			buffer: response.item,
			string: itemId,
			...getItemInfoByAddress(itemId)
		};
		this.mode = response.mode;
		this.period = response.per_num;
		this.isPeriodStarted = Boolean(response.per_started);
		this.requestMode = response.req_mode;
		// this.wdRequestdFtPerc = new cBigNumber(response.req_wd_ft_perc);
		this.wdRequestdFtPerc = new cBigNumber(response.req_wd_ft_perc).mul(100, {raiseValue: true});
		this.wdRequestdUtPerc = new cBigNumber(response.req_wd_ut_perc).mul(100, {raiseValue: true});
		this.usingFt = new cBigNumber(response.using_ft);
		this.usingUt = new cBigNumber(response.using_ut);

		this.isActive = (this.usingFt.gtZero() || this.freeUt.gtZero()) && (this.mode !== 'none' && this.mode !== 'not_set');
		this.haveChanges =	// check
			// (this.requestMode !== 'none')
			(this.requestMode !== 'none' && this.mode !== 'not_set') ||
			(this.freeFt.gtZero() && (this.mode === 'bl' || this.mode === 'blsh' || this.mode === 'blsh_not_sell_cheaper')) ||
			(this.freeUt.gtZero() && (this.mode === 'sh' || this.mode === 'blsh' || this.mode === 'blsh_not_sell_cheaper'))
		;
	}
}